const ProfileIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="18"
			height="18"
			viewBox="0 0 20.454 26.462">
			<defs></defs>
			<g transform="translate(0 0)">
				<path
					className="a"
					d="M134.818,13.636A6.818,6.818,0,1,0,128,6.818,6.818,6.818,0,0,0,134.818,13.636Zm0-11.363a4.545,4.545,0,1,1-4.545,4.545A4.545,4.545,0,0,1,134.818,2.273Z"
					transform="translate(-124.591 0)"
				/>
				<path
					className="a"
					d="M74.227,283.459A10.238,10.238,0,0,0,64,293.686a1.136,1.136,0,0,0,2.273,0,7.954,7.954,0,1,1,15.909,0,1.136,1.136,0,0,0,2.273,0A10.238,10.238,0,0,0,74.227,283.459Z"
					transform="translate(-64 -268.361)"
				/>
			</g>
		</svg>
	);
};
export default ProfileIcon;
